import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import { asset, part, partCategory } from "../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext.jsx";
import { QRCode } from "react-qrcode-logo";

import { useDashboardContext } from "../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import ConfirmationDlg from "../../components/ConfirmationDlg/index.jsx";
import { Loader, formatNumber } from "../../utils/helper";
import DataTable from "react-data-table-component";
import { LocationFilter } from "../../components/LocationFilter/index.jsx";
import ImageViewer from "../../components/ImageViewer";
import { PermissionChecker } from "../../components/PermissionChecker/index.jsx";
import DebounceInput from "../../components/form/HorizontalDebounceInput";

function PartList() {
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState({ page: 1,take:10,totalData:1, part_name:"" });
  const { config } = useAuth();
  const { machineTypes } = useDashboardContext();
  const [deleteRow, setDeleteRow] = useState(null);
  const [changeStatus, setChangeStatus] = useState(null);
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  async function getData() {
    try {
      setLoading(true);
      const queryParam = {
        ...query,
      };
      const res = await part.list(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.results) {
          setDatas(data.results);
        }
        if (data.totalData) {
          setQuery((prev) => ({
            ...prev,
            totalData:data.totalData
          }))
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }

    const handleChangeKeyword = (e) => {
        setQuery((prev) => ({
            ...prev,
            page: 1,
            part_name: e.target.value,
        }));
    };

  const getCategory = async () => {
    const res = await partCategory.list();
    if (res.ok) {
      const body = await res.json();
      setCategories(body.data);
    }
  };

  function changeOperation(value) {
    openChangeStatus(value);
  }

  function generateLocationWording() {
    let result = [];
    if (config && config?.location_wording) {
      const words = config?.location_wording.split(",");
      words.forEach((ln, index) => {
        result.push(ln);
      });
    }

    return result;
  }

  const ExpandedComponent = ({ data }) => {
    return (
      <div style={{ padding: "10px" }}>
        <Card className="border-theme">
          <CardBody>
            <div className={"row"}>
              <div className="col-md-3">
                <ImageViewer src={data?.asset_image}></ImageViewer>
              </div>
              <div className="col-md-9">
                <div>
                  Part Name : <b>{data?.asset_name}</b>
                </div>
                <hr />
                <div>Description: {data?.description}</div>
                <div>QR Code</div>
                <div style={{ display: "block" }}>
                  <QRCode value={data?.barcode} logoImage={"/cmms/logo.png"} />
                </div>
                <button
                  style={{ marginRight: "10px" }}
                  onClick={() => navigate("/assets/detail/" + data.id)}
                  type="button"
                  className="btn btn-outline-theme"
                >
                  View Detail
                </button>
                <button
                  onClick={() => navigate("/assets/edit/" + data.id)}
                  type="button"
                  style={{ marginRight: "10px" }}
                  className="btn btn-outline-theme"
                >
                  <i className="fa fa-edit"></i> Edit Part
                </button>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  };

  function showConfirmationDlg(row) {
    setDeleteRow(row);
  }

  function hideConfirmationDialog() {
    setDeleteRow(null);
  }

  function openChangeStatus(value) {
    setChangeStatus(value);
  }

  function hideChangeStatus() {
    setChangeStatus(null);
  }

  function countOnlineOffline(machine) {
    let online = 0;
    let offline = 0;
    machine.machine_elements.forEach((cm) => {
      if (
        cm.deployments[0]?.sensor?.sensor_uptime[0]?.on_off_status === "true"
      ) {
        online++;
      } else {
        offline++;
      }
    });
    return { online, offline };
  }

  async function deleteData() {
    try {
      const response = await part.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("This part has been deleted");

          setDeleteRow(null);
          await getData();
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  const columns = [
    {
      name: "Image",
      selector: (row) => row.part_image,
      cell: (row) => (
        <div style={{ width: "100px", padding: "5px" }}>
          <ImageViewer src={row.part_image} />
        </div>
      ),
    },
    {
      name: "Part Name",
      selector: (row) => row.part_name,
      minWidth: "150px",
    },
    {
      name: "Part Number",
      selector: (row) => row.part_number,
    },
    {
      name: "Part Cost",
      selector: (row) => row.part_cost,
      cell: (row) => (
        <div>
          {config?.currency_symbol}
          {formatNumber(row.part_cost)}
        </div>
      ),
    },

    {
      name: "Category",
      selector: (row) => row.category?.name,
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex">
          <button
            className="btn btn-sm btn-outline-theme me-2"
            onClick={() => {
              navigate(`/part/edit/${row.id}`);
            }}
          >
            View
          </button>
<PermissionChecker permissions={["delete part"]} hideIfNotAllowed>
          <button
            className="btn btn-sm btn-outline-danger ml-2"
            onClick={() => {
              showConfirmationDlg(row);
            }}
          >
            Delete
            </button>
            </PermissionChecker>
        </div>
      ),
    },
  ];

  const handleChangeLocationFilter = (location_id) => {
    setQuery((prev) => ({
      ...prev,
      location_id: location_id ? location_id : "",
    }));
  };

  const handleChangeCategory = (id) => {
    setQuery((prev) => ({
      ...prev,
      page:1,
      category_id: id,
    }));
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [query.page,query.take,query.category_id, query.part_name]);

  useEffect(() => {
    getCategory();
  }, []);

  const onChangeStatus = (e) => {
    setChangeStatus((prev) => ({
      ...prev,
      machine_status: e.target.value,
    }));
  };

  const prosesChangeStatus = async () => {
    try {
      const response = await asset.updateStatus(
        changeStatus.id,
        changeStatus.machine_status
      );
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("Machine Status has been changed");

          setChangeStatus(null);
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">PART</a>
            </li>
            <li className="breadcrumb-item active">PART LIST</li>
          </ul>

          <h1 className="page-header">Part List</h1>

          <hr className="mb-4" />

          <div id="datatable" className="mb-5">
            <div className="row mb-2 justify-content-sm-end">
                <div className="col-sm-3 mb-2 mb-sm-0">
                    <DebounceInput name="keyword" placeholder={'Search part name'} showDebounceIndicator delay={1000} onchange={handleChangeKeyword} />
                </div>
              <div className="col-sm-3 mb-2 mb-sm-0">
              </div>
              <div className="col-sm-3 mb-2 mb-sm-0">
                <select
                  className="form-select btn btn-outline-theme"
                  defaultValue=""
                  onChange={(e) => {
                    handleChangeCategory(e.target.value);
                  }}
                >
                  <option value="">- Part Category -</option>
                  {categories.map((c, i) => (
                    <option value={c.id}>{c.name}</option>
                  ))}
                </select>
              </div>
              <div className="col-sm-3 mb-2 mb-sm-0">
                <button
                  onClick={() => {
                    navigate("/part/add");
                  }}
                  className="btn btn-outline-theme w-100"
                >
                  Add Part <i className="bi bi-plus"></i>
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Card>
                  <CardBody>

                      <DataTable
                        progressPending={loading}
                        pointerOnHover
                        onRowClicked={(row) => navigate(`/part/edit/${row.id}`)}
                        highlightOnHover
                        theme="dark"
                        columns={columns}
                        data={datas}
                        pagination
                        paginationServer
                        onChangeRowsPerPage={(row)=>setQuery((prev)=>({...prev,page:1,take:row}))}
                        paginationTotalRows={query.totalData}
                        onChangePage={(page)=>setQuery((prev)=>({...prev,page:page}))}
                      />

                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>

      {deleteRow && (
        <ConfirmationDlg
          title={"Delete Part"}
          open={!!deleteRow}
          onClose={hideConfirmationDialog}
          onSubmit={deleteData}
        >
          <p style={{ pb: 2 }}>
            Are you sure you want to delete this part{" "}
            <strong>{deleteRow.part_name}</strong> ?
          </p>
        </ConfirmationDlg>
      )}
    </div>
  );
}

export default PartList;
